import { useEffect, useState } from "react";
import { _single } from "../../../core/services/dataBean/EntityCatalog";
import { YearSelector } from "../../../core/shared/inputs/YearSelector";
import { SelectBudgetType } from "../../admin/configuracion/select/SelectBudgetType";
import { SelectBudgetIDType } from "../../admin/configuracion/select/SelectBudgetIDType";
import { SelectBudgetStructure } from "../../admin/configuracion/BudgetStructure/SelectBudgetStructure";
import { PrintJson } from "../../theme/Component/PrintJson";
import { SelectBudgetTypes } from "../../erp/cellEditor/AccountantConcept/SelectBudgetTypes";

interface Props {
    onChange: Function;
}

export const BudgetSheetFactoryForm = ({ onChange }: Props) => {

    const [response, setResponse] = useState<any>({
        Year: _single.getCurrenYear(),

    });
    const [type, setType] = useState<number>(26);

    useEffect(() => {
        onChange(response)
    }, [response])

    return (
        <div className="row">
            <div className="col-md-2">
                <YearSelector value={response.Year} tittle="Año Presupuesto" onChange={(e) => { setResponse((prev: any) => ({ ...prev, "Year": e })) }} />
            </div>
            <div className="col-md-3">
                <SelectBudgetTypes label="Tipo Presupuesto" idSelector={type} onChange={(e) => { setType(parseInt(e)) }} />
            </div>
            <div className="col-md-3">
                <SelectBudgetType idType={type} idSelector={response.IDBudgetType} onChange={(e) => { setResponse((prev: any) => ({ ...prev, "IDBudgetType": e })) }} label="Tipo de Presupuesto" />
            </div>
            <div className="col-md-3">
                <SelectBudgetIDType idSelector={response.IDBudgetIDType} onChange={(e) => { setResponse((prev: any) => ({ ...prev, "IDBudgetIDType": e })) }} label="Tipo de Catálogo Presupuestal" />
            </div>
            <div className="col-md-12">
                <label>Descripción</label>
                <textarea className="form-control" value={response.Description} onChange={(e) => { setResponse((prev: any) => ({ ...prev, "Description": e.target.value })) }} />
            </div>
            {/* <PrintJson json={response} /> */}
        </div>
    )
}